// extracted by mini-css-extract-plugin
export default {"wrapper":"date-of-birth-field_wrapper"};